import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";

const participantes = [
  { label: "Propietarios individuales", icon: "ri-user-star-line" },
  { label: "Conductores independientes", icon: "ri-steering-2-line" },
  { label: "Personas con uno o varios vehículos", icon: "ri-truck-line" },
  { label: "Empresas transportistas", icon: "ri-building-2-line" },
  { label: "Empresas con flotas", icon: "ri-roadster-line" },
  { label: "Operadores de camiones", icon: "ri-truck-fill" },
  { label: "Operadores de vans", icon: "ri-bus-2-line" },
  { label: "Operadores de autobuses", icon: "ri-bus-line" },
  { label: "Proveedores de transporte especializado", icon: "ri-e-bike-2-line" },
];

const pasos = [
  {
    titulo: "Regístrate",
    descripcion: "Envía tus datos y registra tus vehículos con su información de operación.",
    icon: "ri-edit-box-line",
  },
  {
    titulo: "Verificamos tu información",
    descripcion: "AXONIA GROUP revisará la información proporcionada y tu documentación.",
    icon: "ri-search-eye-line",
  },
  {
    titulo: "Activamos tu perfil",
    descripcion: "Una vez aprobado, tus vehículos podrán formar parte de la red disponible.",
    icon: "ri-shield-check-line",
  },
  {
    titulo: "Recibe oportunidades",
    descripcion:
      "Cuando exista una necesidad compatible con tus vehículos y disponibilidad, podremos contactarte.",
    icon: "ri-notification-3-line",
  },
];

const beneficios = [
  {
    titulo: "Sin límite de unidades",
    descripcion: "Registra uno o varios vehículos, o toda la flota de tu empresa.",
    icon: "ri-stack-line",
  },
  {
    titulo: "Tú defines tu disponibilidad",
    descripcion: "Indica días, horarios y zonas de operación para cada unidad.",
    icon: "ri-calendar-schedule-line",
  },
  {
    titulo: "Documentación privada",
    descripcion: "Guarda matrículas, seguros y licencias de forma segura y confidencial.",
    icon: "ri-lock-2-line",
  },
  {
    titulo: "Perfil con estado",
    descripcion: "Sigue el proceso: pendiente, en revisión, aprobado, activo y más.",
    icon: "ri-flow-chart",
  },
];

export function ParticipantesSection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <Container>
        <SectionHeading
          align="center"
          eyebrow="Quiénes pueden participar"
          title="Buscamos propietarios, conductores y empresas de transporte"
          description="Si tienes un vehículo o una flota y quieres nuevas oportunidades de servicio, este programa es para ti."
        />
        <ul className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {participantes.map((item) => (
            <li
              key={item.label}
              className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                <i className={`${item.icon} text-lg leading-none`} aria-hidden="true"></i>
              </span>
              <span className="text-sm font-medium text-foreground-900">{item.label}</span>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}

export function ProcesoSection() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <Container>
        <SectionHeading
          align="center"
          eyebrow="¿Cómo funciona?"
          title="Cuatro pasos para unirte a la red"
          description="El proceso es una solicitud sujeta a revisión administrativa. No garantiza contratación automática, trabajos ni ingresos."
        />
        <ol className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {pasos.map((paso, index) => (
            <li key={paso.titulo} className="rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${paso.icon} text-xl leading-none`} aria-hidden="true"></i>
                </span>
                <span className="text-2xl font-heading font-bold text-background-300">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-4 text-base font-heading font-semibold text-foreground-950">
                {paso.titulo}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{paso.descripcion}</p>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}

export function BeneficiosSection() {
  return (
    <section className="bg-secondary-50 py-12 md:py-16">
      <Container>
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <SectionHeading
            eyebrow="Ventajas"
            title="Un módulo pensado para transportistas"
            description="Diseñado para registrar vehículos, documentación y disponibilidad de forma ordenada y profesional."
          />
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {beneficios.map((item) => (
              <div
                key={item.titulo}
                className="rounded-lg border border-secondary-200 bg-background-50 p-4"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                  <i className={`${item.icon} text-lg leading-none`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 text-sm font-heading font-semibold text-foreground-950">
                  {item.titulo}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}